import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "@/lib/axios";

export const fetchPdfByCaseId = createAsyncThunk(
  "pdf/fetchByCaseId",
  async (caseId: number, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `/get_pdf_by_case_id?case_id=${caseId}`,
        null,
        {
          // Served by the Java case-db-service (migrated from safety-db).
          service: "case-db",
          responseType: "blob",
          headers: {
            Accept: "application/json",
          },
          meta: { skipLoader: true }, // Custom meta for loader
        } as any
      );

      const blob = response.data;
      const blobUrl = URL.createObjectURL(blob);
      return blobUrl;
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to fetch PDF");
    }
  }
);

export const fetchPdfByAttachmentId = createAsyncThunk(
  "pdf/fetchByAttachmentId",
  async (attachmentId: number, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `/get_pdf_by_attachment_id?attachment_id=${attachmentId}`,
        null,
        {
          responseType: "blob",
          headers: {
            Accept: "application/pdf",
          },
          // @ts-expect-error: 'meta' is not part of AxiosRequestConfig but is used for custom middleware
          meta: { skipLoader: true }, // Custom meta for loader
        }
      );

      const blob = response.data;
      const blobUrl = URL.createObjectURL(blob);
      return blobUrl;
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to fetch attachment PDF");
    }
  }
);
